import { mainMenu, dropdownMenu } from './menu';
import headerInit from './header';
import { getElement, getElements, ifSelectorExist, ready } from './utils';
import { initSliders } from './sliders';

// cookie banner
const acceptCookies = () => {
  const cookieBanner = document.querySelector('.cookie-banner');
  const acceptButton = document.querySelector('.accept-button');
  const declineButton = document.querySelector('.decline-button');

  if ((ifSelectorExist(acceptButton) && ifSelectorExist(cookieBanner)) || declineButton) {
    declineButton.addEventListener('click', (e) => {
      e.preventDefault();
      cookieBanner.style.opacity = '0';
      setTimeout(() => {
        cookieBanner.style.display = 'none';
      }, 2500); // wait for transition to complete before hiding banner
    });

    if (document.cookie.includes('cookiesAccepted=true')) {
      cookieBanner.style.display = 'none';
    } else {
      acceptButton.addEventListener('click', (e) => {
        e.preventDefault();
        cookieBanner.style.opacity = '0';
        setTimeout(() => {
          cookieBanner.style.display = 'none';
        }, 2500); // wait for transition to complete before hiding banner
        document.cookie = 'cookiesAccepted=true; max-age=2592000'; // set cookie to expire in 30 days
      });
    }
  }
};

const toggleLeaderboard = () => {
  const hiddenTr = getElements('.toggable-tr');
  const toggleLeaderboardButton = getElement('.show_leaderboard');
  const toggleLeaderboardButtonSvg = getElement('svg', toggleLeaderboardButton);

  if (ifSelectorExist(toggleLeaderboardButton) && ifSelectorExist(hiddenTr)) {
    toggleLeaderboardButton.addEventListener('click', (e) => {
      e.preventDefault();

      console.log('click');
      toggleLeaderboardButton.classList.toggle('toggled');
      toggleLeaderboardButtonSvg.classList.toggle('toggled');
      Array.from(hiddenTr).forEach((item) => {
        item.classList.toggle('hidden');
      });
    });
  }
};

const toggleTableHeight = ()=> {
  const toggleButton = document.getElementById('toggleButton');
  const tableRows = document.querySelectorAll('.waffle tr');
  const halfwayPoint = Math.ceil(tableRows.length / 2);

  // Initially hide the second half of the rows
  for (let i = halfwayPoint; i < tableRows.length; i++) {
      tableRows[i].classList.add('hidden');
  }

  // Add click event listener to the toggle button
  toggleButton.addEventListener('click', function() {
      let isAnyRowVisible = false;

      for (let i = halfwayPoint; i < tableRows.length; i++) {
          tableRows[i].classList.toggle('hidden');
          if (!tableRows[i].classList.contains('hidden')) {
              isAnyRowVisible = true;
          }
      }

      // Toggle the button text and 'clicked' class
      if (isAnyRowVisible) {
          toggleButton.textContent = 'Show Less';
          toggleButton.classList.add('clicked');
      } else {
          toggleButton.textContent = 'Show More';
          toggleButton.classList.remove('clicked');
      }
  });
}

ready(() => {
  mainMenu();
  dropdownMenu();
  headerInit();
  initSliders();
  acceptCookies();
  toggleLeaderboard();
  toggleTableHeight();
});
